import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void | boolean;
  header?: React.ReactNode;
  headerColor?: string;
  body: React.ReactNode;
  footer?: React.ReactNode;
  submitFun?: any;
  size?: any;
  noCloseBtn?: boolean;
  noHeader?: boolean;
  scrollBehavior?: any;
  closeOnOverlayClick?: boolean;
  p?: any;
  borderRadius?: any;
  transparent?: boolean;
  animate?: boolean;
  isCentered?: any;
  width?: any;
  rounded?: any;
};

export default function CommonModal({
  isOpen,
  onClose,
  header,
  headerColor="teal.500",
  body,
  footer,
  submitFun,
  size,
  noCloseBtn,
  noHeader,
  scrollBehavior,
  closeOnOverlayClick,
  p,
  borderRadius,
  transparent,
  animate,
  isCentered,
  width,
  rounded,
}: ModalProps): JSX.Element {
  const blueClr: string = "rgb(33, 173, 232)";
  const [values, setValues] = useState<any[]>([]);

  // const viewerWidth = useBreakpointValue({ lg: true });

  return (
    <Modal
      size={{ base: "xs", md: size ? size : "md" }}
      isOpen={isOpen}
      onClose={onClose}
      isCentered={isCentered ? true : false}
      scrollBehavior={scrollBehavior}
      closeOnOverlayClick={closeOnOverlayClick}
    >
      <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
      <ModalContent
        position={animate ? "fixed" : "relative"}
        right={animate ? (isOpen ? "0" : `-${width}`) : "unset"}
        top={animate ? "0" : "unset"}
        h={animate ? "100vh" : "unset"}
        width={animate ? width : "100vw"}
        minW={width}
        bg={transparent ? "transparent" : "white"}
        boxShadow={transparent ? "transparent" : "inherit"}
        animation={
          animate
            ? `${isOpen ? "slideIn" : "slideOut"} 0.8s ease-in-out forwards `
            : "none"
        }
        mt={animate === true ? "0px" : undefined}
        rounded={rounded}
        overflow={'auto'}
        className="customScrollBar"
        py={2}
      >
        <ModalHeader
          display={noHeader ? "none" : "block"}
          fontSize={{ base: "md", lg: "xl" }}
          color={headerColor ? headerColor : blueClr}
          fontWeight="700"
          pb={0}
        >
          {header}
        </ModalHeader>
        <ModalCloseButton display={noCloseBtn ? "none" : "block"} />
        <ModalBody
          borderRadius={borderRadius ? borderRadius : undefined}
          p={p ? p : undefined}
          className="customScrollBar"
          pt={{ base: 0, md: "unset" }}
        >
          {body}
        </ModalBody>
        {footer && (
          <ModalFooter>
            {footer}
            {submitFun && <Button onClick={submitFun}> Submit</Button>}
          </ModalFooter>
        )}
      </ModalContent>
      <style>
        {`
            @keyframes slideIn {
              from {
                right: -${width};
              }
              to {
                right: 0;
              }
            }

            @keyframes slideOut {
              from {
                right: 0;
              }
              to {
                right: -${width};
              }
            }

            `}
      </style>
    </Modal>
  );
}
